(() => {
  const copy = {
    de: {
      title: 'Geführte Auswahl verlassen?',
      text: 'Deine Auswahl bleibt auf diesem Gerät gespeichert.',
      stay: 'Auswahl fortsetzen',
      leave: 'Jetzt verlassen',
      restart: 'Auswahl löschen und neu starten',
      open: 'Auswahl verlassen'
    },
    fr: {
      title: 'Quitter le parcours guidé ?',
      text: 'Votre sélection reste enregistrée sur cet appareil.',
      stay: 'Continuer la sélection',
      leave: 'Quitter maintenant',
      restart: 'Effacer et recommencer',
      open: 'Quitter la sélection'
    },
    en: {
      title: 'Leave the guided selection?',
      text: 'Your selection remains saved on this device.',
      stay: 'Continue selecting',
      leave: 'Leave now',
      restart: 'Clear selection and restart',
      open: 'Leave selection'
    },
    ar: {
      title: 'هل تريد مغادرة الاختيار الموجّه؟',
      text: 'سيبقى اختيارك محفوظاً على هذا الجهاز.',
      stay: 'متابعة الاختيار',
      leave: 'المغادرة الآن',
      restart: 'مسح الاختيار والبدء من جديد',
      open: 'مغادرة الاختيار'
    }
  };
  const focusableSelector = 'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  document.querySelectorAll('[data-guided-exit]').forEach((root, index) => {
    const workspace = root.querySelector('[data-guided-workspace],[data-skin-workspace]');
    const start = root.querySelector('[data-guided-start],[data-skin-start]');
    if (!workspace || !start) return;
    const strings = copy[(document.documentElement.lang || 'de').slice(0, 2)] || copy.de;
    const openers = [...root.querySelectorAll('[data-guided-exit-open]')];
    openers.forEach(opener => {
      if (!opener.dataset.preserveLabel) opener.textContent = strings.open;
    });

    const dialog = document.createElement('dialog');
    const titleId = `GuidedExitTitle-${index}`;
    dialog.className = 'guided-exit';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', titleId);
    dialog.innerHTML = `<div class="guided-exit__surface"><h2 id="${titleId}"></h2><p data-guided-exit-text></p><div class="guided-exit__actions"><button class="button" type="button" data-guided-exit-stay></button><button class="button button--secondary" type="button" data-guided-exit-leave></button><button class="guided-exit__restart" type="button" data-guided-exit-restart></button></div></div>`;
    dialog.querySelector('h2').textContent = strings.title;
    dialog.querySelector('[data-guided-exit-text]').textContent = strings.text;
    dialog.querySelector('[data-guided-exit-stay]').textContent = strings.stay;
    dialog.querySelector('[data-guided-exit-leave]').textContent = strings.leave;
    dialog.querySelector('[data-guided-exit-restart]').textContent = strings.restart;
    root.append(dialog);

    let returnTarget = openers[0] || start;
    const nativeDialog = typeof dialog.showModal === 'function';
    const isOpen = () => dialog.hasAttribute('open');
    const close = (restore = true) => {
      if (nativeDialog && dialog.open) dialog.close();
      else {
        dialog.removeAttribute('open');
        dialog.removeAttribute('data-open');
        dialog.hidden = true;
        document.body.classList.remove('guided-dialog-open');
      }
      if (restore && returnTarget?.isConnected) returnTarget.focus();
    };
    const open = (trigger = openers[0] || document.activeElement) => {
      if (isOpen()) return;
      returnTarget = trigger instanceof HTMLElement ? trigger : openers[0] || start;
      if (nativeDialog) dialog.showModal();
      else {
        dialog.hidden = false;
        dialog.setAttribute('open', '');
        dialog.setAttribute('data-open', '');
        document.body.classList.add('guided-dialog-open');
      }
      dialog.querySelector('[data-guided-exit-stay]').focus();
    };

    openers.forEach(opener => opener.addEventListener('click', () => open(opener)));
    dialog.querySelector('[data-guided-exit-stay]').addEventListener('click', () => close());
    dialog.querySelector('[data-guided-exit-leave]').addEventListener('click', () => {
      close(false);
      if (root.dataset.exitUrl) {
        window.location.assign(root.dataset.exitUrl);
      } else {
        workspace.hidden = true;
        root.dispatchEvent(new CustomEvent('guided:exit'));
        if (start) {
          start.hidden = false;
          start.classList.remove('visually-hidden');
          start.focus();
        }
      }
    });
    dialog.querySelector('[data-guided-exit-restart]').addEventListener('click', () => {
      root.dispatchEvent(new CustomEvent('guided:restart'));
      close(false);
      workspace.hidden = false;
      workspace.querySelector('h2')?.focus();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || nativeDialog) return;
      const items = [...dialog.querySelectorAll(focusableSelector)];
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    document.addEventListener('focusin', (event) => {
      if (nativeDialog || !isOpen() || dialog.contains(event.target)) return;
      dialog.querySelector('[data-guided-exit-stay]').focus();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || workspace.hidden || isOpen()) return;
      event.preventDefault();
      open(document.activeElement);
    });
    dialog.hidden = !nativeDialog;
  });
})();